<template>
  <!--Popover for learning groups-->
  <v-card elevation="0" :style="routerView ? 'width: 100vw;' : ''">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">people</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content class="modal-title">
          <span class="text-white">Learner Group Sets</span>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <!-- [ ] need to import lmsType -->
      <v-tabs grow v-model="groupsTab" v-show="hasCanvasApi && LMSdata.type === 'Canvas'">
        <v-tab :disabled="!_.get(school, 'config.permissions', []).includes('manageGroups') && !_.get(school, 'config.permissions', []).includes('hasPeerReview')">
          Manage Group Sets
        </v-tab>
        <v-tab>
          Import Group Sets
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="groupsTab">
        <v-tab-item :key="0" >
          <GroupEdit :sectionId="sectionId" :height="viewHeight"></GroupEdit>
        </v-tab-item>
        <v-tab-item :key="1">
          <!-- move this to GroupImport.vue -->
          <!-- Fix this if the tabs are removed due to non-Canvas LMS -->
          <v-card elevation="0" :height="viewHeight">
            <div class="import-groups-container" v-if="popoverDataLoading">
               <v-progress-circular color="grey" indeterminate size=40 :width="5">
               </v-progress-circular>
            </div>
            <div class="import-groups-container" v-if="!popoverDataLoading && canvasGroups.length === 0">
              <v-btn class="branded-text branded-border" @click="importGroups" v-if="LMSdata.groupImport">
                Fetch Group Sets
              </v-btn>
              <Tooltip top v-if="!LMSdata.groupImport">
                <v-btn class="branded-background text-white">
                  Fetch Group Sets
                </v-btn>
                <template v-slot:text>
                  Canvas authorization token needed. Please contact PlayPosit support.
                </template>
              </Tooltip>
              <span class="mt-2" v-if="!popoverDataLoading">No Canvas Groups</span>
            </div>
            <div class="import-groups-container-loaded" v-if="!popoverDataLoading && canvasGroups.length > 0">
              <div class="import-tree">
                <div class="px-4 py-3">
                  <span style="font-size: 16px">{{canvasGroups.length}} group sets imported from Canvas</span>
                </div>
                <div class="px-3 py-4">
                  <v-treeview :items="ltiGroupSets">
                    <template v-slot:prepend="{ item }">
                      <img v-if="item.type === 'group_set' && item.lmsImg" class="lms-img-sm" :src="item.lmsImg">
                      <v-icon v-if="item.type === 'group_set' && !item.lmsImg">group_work</v-icon>
                      <v-icon v-if="item.type === 'group'">group</v-icon>
                      <v-icon v-if="item.type === 'student'">person</v-icon>
                    </template>
                    <template v-slot:append="{ item }">
                      <Tooltip v-if="item.type === 'group_set'" top>
                        <v-btn icon @click="reimportGroupSet(item.id)">
                          <v-icon >refresh</v-icon>
                        </v-btn>
                        <template v-slot:text>
                          Resync group set.
                        </template>
                      </Tooltip>
                    </template>
                  </v-treeview>
                </div>
              </div>
              <div class="import-reload">
                <v-btn class="branded-text branded-border" @click="importGroups">
                  Fetch Group Sets
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="handleSaveAndClose"
        class="primary"
        :class="{ 'mb-3': routerView }"
        flat>
        Save and Close
      </v-btn>
    </v-card-actions>
  </v-card>
  
</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import storejs from 'store';

import GroupEdit from './GroupEdit';

export default {
  name: 'Group',
  components: {
    GroupEdit
  },
  props: [ 
    'sectionId',
    'initialTab',
    'routerView'
  ], 
  data() {
    return {
      groupsTab: 0,
    }
  },
  computed: {
    ...mapGetters([
      'popoverDataLoading',
      'LTIlaunch',
      'LMSdata',
      'slideOutLarge',
      'school',
      'hasCanvasApi'
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'groups',
    ]),
    canvasGroups() {
      if(this.groups.length > 0){
        let canvasarray = []
        this.groups.forEach(item => {
          if (item.source === 'canvas') {
            canvasarray.push(item)
          }
        })
        return canvasarray;
      } else {
        return [];
      }
    },
    ltiGroupSets() {
      return _.filter(this.groups, gs => gs.source !== 'playposit')
    },
    viewHeight() {
      // handle extra height when the tabs are hidden
      if (this.hasCanvasApi && _.get(this.LMSdata, 'type', 'Default') === 'Canvas') return 'calc(100vh - 165px)'
      return 'calc(100vh - 108px)';
    },
  },
  methods: {
    ...mapMutations([
      'handleDialogOpen',
      'triggerSnackbar',
      'slideOut',
      'setBluescreenData',
      'setIsRouterView',
    ]),
    ...mapActions('instructors', [
      'getLearnerGroups',
    ]),
    close() {
      // reload learner groups so any newly created PlayPosit groups populate for the popover
      this.getLearnerGroups(this.sectionId);
      // turn lti popover backon
      this.slideOut({toggle: false, view: null})
    },
    handleSaveAndClose() {
      if (this.routerView) {
        this.promptToReturn();
        storejs.set('refreshGroups', true);
      } else {
        this.close();
      }
    },
    importGroups() {
      if (this.LMSdata.type === 'Canvas') {
        this.$store.dispatch('canvas/importGroups', { sectionId: this.sectionId});
      } else {
        this.triggerSnackbar({
          text:`${this.LMSdata.type} Group Import is Not Supported`,
          color: 'warning',
          timeout: 6000
        });
      }
    },
    reimportGroupSet(groupSetId) {
      this.$store.dispatch('canvas/reimportGroupSet', groupSetId)
    },
    promptToReturn() {
      this.setBluescreenData({
        title: 'Group sets saved.',
        subtitle: 'You may close this window.',
        text: `You may now close this window and return to your classroom. Your group data has been saved.`,
        buttons: [ { text: 'Close', action: 'close',  order: 1 }, ]
      }, { root: true });
    },
  },
  beforeMount() {
    if (this.routerView) this.setIsRouterView(true);
  },
  async mounted() { 
    if ([0, 1].includes(this.initialTab)) {
      this.groupsTab = this.initialTab;
    }
    if (!this.routerView) await this.getLearnerGroups(this.sectionId);
  },
};
</script>

<style>
  .import-reload {
    width: 35%;
    padding-top: 6px;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
  }
  
  .sortable-choosen {
    cursor: grabbing !important;
  }
</style>
